<template>
  <div class="page-module-wrap">
    <!-- 搜索头部分 start -->
    <div class="search" style="padding: 10px;">
      <el-collapse accordion is-fullwidth v-model="avtiveCollapse">
        <el-collapse-item title="商品导入区" name="1">
          <div class="tile is-parent">
            <article class="tile is-child box">
              <div class="section-gap">
                <div class="block">
                  <div class="control">
                    <label class="label">是否需要加限时折扣状态?</label>
                    <el-radio-group v-model="isShowCountDown"  @change="onClickShowCountDown">
                      <el-radio class="radio"  label="1" >是</el-radio>
                      <el-radio class="radio margin-left"  label="0" >否</el-radio>
                    </el-radio-group>
                  </div>
                  <button class="button is-info" @click="checkGoodsList">检查商品</button>
                </div>
              </div>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box">
              <div class="section-gap">
                <div class="block">
                  <el-tabs v-model="activeName2" type="card">
                    <el-tab-pane label="从表格导入" name="first">
                      <!-- <button id="js_ImportCSV" class="button is-info">导入表格</button> -->
                      <button class="button is-info" @click="dialogVisible = true">导入表格</button>
                      <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%">
                        <p>
                          <el-radio v-model="effectWay" :label="1" @change="bindUploadFile">替换已生效数据</el-radio>
                          <span>(商品数据与导入数据对比，时间交错的进行替换)</span>
                        </p>
                        <p>
                          <el-radio v-model="effectWay" :label="2" @change="bindUploadFile">导入数据重复不生效</el-radio>
                          <span>(商品数据与导入的数据对比，时间交错的，导入数据不生效)</span>
                        </p>
                        <span slot="footer" class="dialog-footer">
                          <button @click="dialogVisible = false" class="button is-info">取 消</button>
                          <button id="js_ImportCSV" @click="dialogVisible = false" class="button is-info">确 定</button>
                        </span>
                      </el-dialog>

                      <a class="button is-link" style="display: inline-block;" href="https://image3.ichuanyi.cn/group4/M00/16/59/CgAAKVla-KwEAAAAAAAAAI_TZqU729.csv" target="_blank">表格模板</a>
                      <el-tooltip class="item" effect="dark" content="表格需要包含开始时间、结束时间 （如2017-6-19 20:00:00）、商品ID、改后价格4列" placement="right">
                        <b  class="question-icon r-top margin-left">?</b>
                      </el-tooltip>
                    </el-tab-pane>
                    <el-tab-pane label="通过商品ID添加" name="second">
                      <div class="block">
                        <label class="label inline-block r-top">改价时间</label>
                        <el-date-picker
                          v-model="time"
                          type="datetimerange"
                          placeholder="选择时间范围">
                        </el-date-picker>
                      </div>
                      <div class="block text-area">
                        <label class="label inline-block r-top">添加改价商品</label>
                        <textarea class="textarea inline-block" placeholder="多个ID请使用换行区分，商品默认按照输入顺序排序" v-model="goodsIds"></textarea>
                      </div>
                      <div class="block">
                        <button class="button is-info" @click="onBatchAddByGoodsId">确认添加</button>
                      </div>
                    </el-tab-pane>

                  </el-tabs>
                </div>
              </div>
            </article>
          </div>
          <div class="tile is-parent" v-if="isShowProgress">
            <article class="tile is-child box">
              <div class="section-gap">
                <div class="block" v-for="(item, processId) in processQueue">
                  <div class="control" style="width: 50%;">
                    {{item.description}}【{{processId}}】:<progress style="width: 50%;" class="progress inline-block is-primary" :value="item.completedPercent" :max="100"></progress>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- 搜索头部分 end -->
    <!-- 列表部分 start -->
    <div class="list-wrap">
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="block">
            <label class="label inline-block">批量改价</label>
            <el-tooltip content="商品折扣为0~10之间的数字，小数点后保留四位。折扣价格不能高于商品现价" placement="top-start">
              <b class="question-icon margin-left">?</b>
            </el-tooltip>
          </div>
          <div class="block">
            <label class="label">基于价格：</label>
            <div class="margin-top">
              <label class="label inline-block margin-left"><input type="radio" value="1" v-model="baseBy">基于原价</label>
              <label class="label inline-block margin-left"><input type="radio" value="2" v-model="baseBy">基于现价</label>
            </div>
            <label class="label margin-top">改价类型：</label>
            <div>
              <input type="radio" class="r-top margin-left" value="1" v-model="operationType">
              <label class="label inline-block r-top">打</label>
              <input type="number" class="input width-1" :class="{'is-disabled':operationType == '2'}" v-model="discount">
              <label class="label inline-block r-top">折</label>
              <input type="radio" class="r-top margin-left" value="2" v-model="operationType">
              <label class="label inline-block r-top">提价</label>
              <input type="number" class="input width-1" :class="{'is-disabled':operationType == '1'}" v-model="percent">
              <label class="label inline-block r-top">%</label>
            </div>
            <div class="margin-top">
              <button class="button is-success" @click="onBatchSetDiscount">设置</button>
            </div>
          </div>
          <table class="table is-bordered">
            <thead>
              <tr>
                <th style="width:186px;">时间</th>
                <th>商品ID</th>
                <th>商品名称</th>
                <th>商品图</th>
                <th style="min-width: 60px;">商品库存</th>
                <th class="min-width">原价</th>
                <th class="min-width">现价</th>
                <th>折扣</th>
                <th>改后现价</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in list">
                <td>
                  <span :class="{'is-error':!item.canAdd}">{{formatDate(item.startTime)}}~<br/>{{formatDate(item.endTime)}}</span>
                  <p v-if="item.canAdd == 0" class="is-error">{{item.errorMessage}}</p>
                </td>
                <td>
                  {{item.goodsId}}
                </td>
                <td>
                  {{item.name}}
                </td>
                <td>
                  <image-component :image='item.image' :width='180'></image-component>
                </td>
                <td>
                  {{item.stockCount}}
                </td>
                <td>
                  ￥{{item.originalPrice}}
                </td>
                <td>
                  ￥{{item.price}}
                </td>
                <td>
                  <div class="input-swap">
                    <input class="input width-1" type="number" v-model="item.discount" @blur="onBlur(index,1)">
                    <label class="inline-block r-top">折</label>
                  </div>
                </td>
                <td>
                  <div class="input-swap">
                    <label class="inline-block r-top">￥</label>
                    <input class="input width-1" type="number" v-model="item.thatTimePrice" @blur="onBlur(index,2)">
                  </div>
                </td>
                <td>
                  <button class="button is-danger" @click="onDelete(index)">删除</button>
                  <a class="button is-warning" target="_blank" :href="'/admin.php?method=goods.view&goodsId='+item.goodsId">库存</a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="block" v-if="list.length == 0">
            <span class="data-isnull">暂无数据显示</span>
          </div>
          <div class="block">
            <button class="button is-info width-1" :class="{'is-disabled':!canSubmit}" @click="onSubmit">提 交</button>
          </div>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import {getTimeByDateStr, formatDate} from 'UTILS/date'
export default {
  data () {
    return {
      dialogVisible: false,
      effectWay: 1, // 1:替换已生效数据  2:导入数据重复不生效
      isShowCountDown: '0',
      startTime: '',
      endTime: '',
      goodsIds: '',
      baseBy: '1', // 1:基于原价  2：基于现价
      operationType: '1', // 改价方式  1:批量打折   2:批量提价
      percent: '', // 提价百分比
      discount: '', // 折扣
      operationId: '',
      list: [],
      canSubmit: false,
      count: 0,
      search: {
        page: 1,
        pageSize: 15
      },
      isShowProgress: false,
      processQueue: {}, // 用来存储定时器
      activeName2: 'first', // tab页的切换
      time: [], // 改价时间
      avtiveCollapse: '1'// 商品导入去保持展开状态

    }
  },
  mounted () {
    setTimeout(() => {
      this.bindUploadFile()
    }, 500)
    if (this.$route.query.operationId) {
      this.operationId = this.$route.query.operationId
      this.initOperation()
      this.getList()
    } else {
      this.getOperationId()
    }
  },
  destroyed () {
    _.each(this.processQueue, (item, key) => {
      clearInterval(item.timerId)
    })
  },
  watch: {
    /**
       * 监听任务队列的变化，如果有完成的任务，则重新请求去渲染商品列表
       */
    processQueue () {
      this.isShowProgress = true
      _.each(this.processQueue, (item, key) => {
        if (item.completedPercent == 100) {
          clearInterval(item.timerId)
          this.getList()
          delete this.processQueue[key]
          this.$message('操作成功!')
        }
      })
      if (!Object.keys(this.processQueue).length) {
        this.isShowProgress = false
      }
    },
    operationType () {
      this.percent = ''
      this.discount = ''
    }
  },
  methods: {
    formatDate (timeStamp) {
      return formatDate(timeStamp)
    },
    /**
       * 获取一个新的操作ID
       */
    getOperationId () {
      HttpRequest.get('/admin/goods/time-limit/batch-operation/get-new-id').then(response => {
        this.operationId = response.data.operationId
        this.$router.push('/activity/showTimeLimitPrice?operationId=' + this.operationId)
        this.initOperation()
      })
    },
    /**
       * 初始化操作数据
       */
    initOperation () {
      HttpRequest.get(`/admin/goods/time-limit/batch-operation/${this.operationId}`).then(response => {
        this.isShowCountDown = response.data.isShowCountDown ? '1' : '0'
        this.canSubmit = response.data.canSubmit
      })
    },
    /**
       * 获取商品列表
       */
    getList () {
      HttpRequest.get(`/admin/goods/time-limit/batch-operation/${this.operationId}/goods`, this.search).then(response => {
        this.list = _.toArray(response.data.list)
        this.count = response.data.count
        this.initOperation()
      })
    },
    /**
       * 绑定上传
       */
    bindUploadFile () {
      // console.log(this.effectWay,'this.effectWay111');
      var isMulti = false
      var id = 'js_ImportCSV'
      // 绑定上传图片控件
      var params = {
        config: {
          pick: {
            id: '#' + id,
            multiple: isMulti
          },
          server: process.env.VUE_APP_PLATFORM + '/admin/goods/time-limit/batch-operation/' + this.operationId + '/file',
          fileVal: 'csv',
          accept: {},
          formData: {
            'PHPSESSID': '',
            'effectWay': this.effectWay
          }
        },
        extensionField: {
          target: this
        },
        events: {
          onSuccess (response, file, uploaderObj) {
            this.onSuccess && this.onSuccess(response, file, uploaderObj)
          }
        }
      }
      new Uploader(params)
    },
    onSuccess (response) {
      let processId = response.data.processId
      if (!this.processQueue[processId]) {
        this.processQueue[processId] = {}
        this.processQueue[processId].description = '表格导入'
      }
      this.getProcessStatus(processId)
    },
    /**
       * 获取批处理进度
       */
    getProcessStatus (processId) {
      if (!processId) {
        return false
      }
      let timerId = setInterval(() => {
        let processQueue = JSON.parse(JSON.stringify(this.processQueue))
        HttpRequest.get(`/admin/goods/time-limit/process/${processId}`).then(response => {
          processQueue[processId].completedPercent = response.data.completedPercent
          if (!processQueue[processId].timerId) {
            processQueue[processId].timerId = timerId
          }
          this.processQueue = processQueue
        })
      }, 1000)
    },
    /**
       * 根据商品ID批量添加商品
       */
    onBatchAddByGoodsId () {
      let goodsIdArr = this.goodsIds.split('\n'),
        params = {}
      this.startTime = this.time[0]
      this.endTime = this.time[1]
      if (!this.startTime || !this.endTime) {
        this.$message('时间不能为空！')
        return false
      }
      for (let i = 0, len = goodsIdArr.length; i < len; i++) {
        goodsIdArr[i] = goodsIdArr[i].trim()
      }
      params = {
        startTime: new Date(this.startTime).getTime() / 1000,
        endTime: new Date(this.endTime).getTime() / 1000,
        goodsIds: goodsIdArr
      }

      HttpRequest.post(`/admin/goods/time-limit/batch-operation/${this.operationId}/goods`, params).then(response => {
        let processId = response.data.processId
        if (!this.processQueue[processId]) {
          this.processQueue[processId] = {}
          this.processQueue[processId].description = '商品ID导入'
        }
        this.getProcessStatus(processId)
        this.startTime = ''
        this.endTime = ''
        this.goodsIds = ''
      })
    },
    /**
       * 删除商品
       */
    onDelete (index) {
      if (!confirm('确认删除?')) {
        return false
      }
      let startTime = this.list[index].startTime,
        endTime = this.list[index].endTime,
        goodsId = this.list[index].goodsId,
        operationId = this.operationId,
        url = `/admin/goods/time-limit/batch-operation/${operationId}/goods/${startTime}/${endTime}/${goodsId}`
      HttpRequest.delete(url).then(response => {
        if (response.data.result) {
          this.$message('删除成功!')
          this.getList()
        }
      })
    },
    /**
       * 批量设置
       */
    onBatchSetDiscount () {
      if (this.percent.trim() === '' && this.discount.trim() === '') {
        this.$message('请填写折扣或者提价百分比')
        return false
      }
      if (this.operationType == 1) { // 改价方式  1:批量打折   2:批量提价
        this.onBatchDiscount()
      } else {
        this.onBatchRaisePrice()
      }
    },
    /**
       * 批量打折商品
       */
    onBatchDiscount () {
      let operationId = this.operationId,
        params = {
          discount: this.discount,
          baseBy: this.baseBy
        }
      HttpRequest.post(`/admin/goods/time-limit/batch-operation/${operationId}/goods/discount`, params).then(response => {
        let processId = response.data.processId
        if (!this.processQueue[processId]) {
          this.processQueue[processId] = {}
          this.processQueue[processId].description = '批量打折商品'
        }
        this.getProcessStatus(processId)
        this.discount = ''
      })
    },
    /**
       * 批量提价商品
       */
    onBatchRaisePrice () {
      let operationId = this.operationId,
        params = {
          percent: this.percent,
          baseBy: this.baseBy
        }
      HttpRequest.post(`/admin/goods/time-limit/batch-operation/${operationId}/goods/raise-price`, params).then(response => {
        let processId = response.data.processId
        if (!this.processQueue[processId]) {
          this.processQueue[processId] = {}
          this.processQueue[processId].description = '批量提价商品'
        }
        this.getProcessStatus(processId)
        this.percent = ''
      })
    },
    /**
       * @param index
       * @param type  1:焦点离开折扣输入框，计算现价   2:焦点离开现价输出框，计算折扣
       */
    onBlur (index, type) {
      let discount = this.list[index].discount * 1,
        originalPrice = this.list[index].originalPrice * 1,
        price = this.list[index].price * 1,
        timePrice = 0,
        operationId = this.operationId,
        startTime = this.list[index].startTime,
        endTime = this.list[index].endTime,
        goodsId = this.list[index].goodsId,
        params = {},
        url = ''
      if (type == 1) {
        timePrice = (originalPrice * discount / 10).toFixed(2) * 1
      } else if (type == 2) {
        timePrice = this.list[index].thatTimePrice * 1
      }
      params = {
        price: timePrice
      }
      url = `/admin/goods/time-limit/batch-operation/${operationId}/goods/${startTime}/${endTime}/${goodsId}`
      HttpRequest.put(url, params).then(response => {
        if (response.data.result) {
          this.getList()
        }
      })
    },
    /**
       * 提交
       */
    onSubmit () {
      let operationId = this.operationId
      this.canSubmit = false
      HttpRequest.post(`/admin/goods/time-limit/batch-operation/${operationId}`).then(response => {
        let processId = response.data.processId
        if (!this.processQueue[processId]) {
          this.processQueue[processId] = {}
          this.processQueue[processId].description = '提交中'
        }
        this.getProcessStatus(processId)
      })
    },
    onClickShowCountDown () {
      setTimeout(() => { // 加延迟处理dom渲染的延迟
        let operationId = this.operationId,
          params = {}
        params = {
          isShowCountDown: this.isShowCountDown
        }
        HttpRequest.put(`/admin/goods/time-limit/batch-operation/${operationId}`, params)
      }, 100)
    },
    /**
       * 检查商品
       */
    checkGoodsList () {
      let operationId = this.operationId
      HttpRequest.post(`/admin/goods/time-limit/batch-operation/${operationId}/goods/check`).then(response => {
        let processId = response.data.processId
        if (!this.processQueue[processId]) {
          this.processQueue[processId] = {}
          this.processQueue[processId].description = '检查中'
        }
        this.getProcessStatus(processId)
      })
    },
    /**
       * 分页
       */
    handleCurrentChange (page) {
      if (this.search.page !== page) {
        this.search.page = page
        this.getList()
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .page-module-wrap {
    .question-icon {
      display: inline-block;
      width: 20px;
      height:20px;
      border-radius: 100%;
      background: rgba(0,0,0,.7);
      color:#fff;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }
    .search {
      .text-area {
        width: 330px;
        .textarea {
          height:200px;
        }
      }
    }
    .list-wrap {
      th {
        text-align: center;
      }
      .min-width {
        min-width: 75px;
      }
      .is-error {
        color:red;
      }
      .input-swap {
        width: 120px;
      }
    }
  }
</style>
